/* eslint-disable */
import PropTypes from 'prop-types';
import ThemeStatePropTypes from '../../State/Store/Theme/Theme.props';

const OrderTitlePropTypes = {
  /**
   * The JSS classes to use
   */
  classes: ThemeStatePropTypes.classes.isRequired,

  /**
   * The subTitle
   */
  subTitle: PropTypes.string.isRequired,

  /**
   * The JSS theme to use
   */
  theme: ThemeStatePropTypes.theme.isRequired,

  /**
   * The title
   */
  title: PropTypes.string.isRequired,
};

export default OrderTitlePropTypes;
